import { makeStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import useCheckMobileScreen from '../../hooks/useWidth';
import Forms from '../../components/DynamicForms';
import TabContext from '../../components/DynamicForms/TabBar';
import LanguageContext from '../../contexts/languageContext';
const styles = makeStyles((theme) => ({
    container: {
        background: '#fff',
        // height: 'calc(100vh - 80px)',
        display: 'flex',
        margin: '-22px',
        borderRadius: '8px',
        [theme.breakpoints.down(1025)]: {
            display: 'block',
            margin: 'unset',
            height: 'unset'
        }
    },
    col1: (props) => ({
        flex: '0 1 25%',
        borderLeft: props.rtl ? 'solid 4px #f2f4fa' : 'none ',
        borderRight: props.rtl ? 'none' : 'solid 4px #f2f4fa ',
        height: 'calc(100vh)',
        position: 'sticky',
        top: '-60px',
        [theme.breakpoints.down(1025)]: {
            height: '100%'
        }
    })
}));

const DynamicForms = () => {
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const isMobile = useCheckMobileScreen();

    return (
        <>
            <div className={classes.container}>
                {!isMobile && (
                    <div className={classes.col1}>
                        <TabContext />
                    </div>
                )}
                <Forms />
            </div>
        </>
    );
};

export default DynamicForms;
